import React from 'react';
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { formatDate, formatHoursOrDash } from './historyFormatters';
import { tableSx, headSx, numSx, valueSx } from './historyTableStyles';

/**
 * TimecardDetailTable — Date | Type | Employee | Foreman | Activity | ST | OT | DT.
 * Oldest first (from API). Type is the timecard's location_type (shop/field).
 * Hours are right-aligned with tabular figures; zero hours render as an em-dash.
 */
// Same SHOP/FIELD chip styling as the timecard grids (Timecard.js).
const renderLocationType = (t) => {
  if (!t) return '—';
  const isShop = t.toLowerCase() === 'shop';
  return (
    <Chip
      label={isShop ? 'SHOP' : 'FIELD'}
      size="small"
      color={isShop ? 'warning' : 'primary'}
      sx={{ fontWeight: 'bold', fontSize: '0.7rem', height: 22 }}
    />
  );
};

function TimecardDetailTable({ rows = [] }) {
  if (!rows.length) {
    return <div className="phm-empty">No records found.</div>;
  }

  return (
    <Table size="small" stickyHeader sx={tableSx}>
      <TableHead>
        <TableRow>
          <TableCell sx={headSx}>Date</TableCell>
          <TableCell sx={headSx}>Type</TableCell>
          <TableCell sx={headSx}>Employee</TableCell>
          <TableCell sx={headSx}>Foreman</TableCell>
          <TableCell sx={headSx}>Activity</TableCell>
          <TableCell sx={{ ...headSx, ...numSx }}>ST hrs</TableCell>
          <TableCell sx={{ ...headSx, ...numSx }}>OT hrs</TableCell>
          <TableCell sx={{ ...headSx, ...numSx }}>DT hrs</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((r, i) => (
          <TableRow key={i}>
            <TableCell sx={valueSx}>{formatDate(r.date)}</TableCell>
            <TableCell sx={valueSx}>{renderLocationType(r.locationType)}</TableCell>
            <TableCell sx={valueSx}>{r.employeeName || '—'}</TableCell>
            <TableCell sx={valueSx}>{r.foremanName || '—'}</TableCell>
            <TableCell sx={valueSx}>{r.activityName || '—'}</TableCell>
            <TableCell sx={numSx}>{formatHoursOrDash(r.hoursSt)}</TableCell>
            <TableCell sx={numSx}>{formatHoursOrDash(r.hoursOt)}</TableCell>
            <TableCell sx={numSx}>{formatHoursOrDash(r.hoursDt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default TimecardDetailTable;
